// extracted by mini-css-extract-plugin
module.exports = {"timelineWrapper":"_202L2","timeline":"_28g9k","isLoading":"_3tc6i","timelineInner":"I8ULC","middle":"_3qPc-","redLine":"_1SPop","left":"_1AVLK","right":"zwW24"};